import { render } from "./CaseBox.vue?vue&type=template&id=4d5d76b7&scoped=true"
import script from "./CaseBox.vue?vue&type=script&lang=js"
export * from "./CaseBox.vue?vue&type=script&lang=js"

import "./CaseBox.vue?vue&type=style&index=0&id=4d5d76b7&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d5d76b7"]])

export default __exports__